import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
  Select,
  Stack,
  Typography
} from '@mui/material';
import Iconify from '../../../../components/Iconify';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { generateUniqueId } from './AddNewHouseDialog';

export const ChanegAgeRangeDialog = props => {
  const { open, setOpen, node, allNodes, onPaneClick } = props;
  const { nodes, removeNode, addNodesF } = useAccomodationDiagram();
  const [selectedAgeRange, setSelectedAgeRange] = React.useState(node.parentId);
  const ageRangeNodes = nodes.filter(n => n.type === 'AgeRangeNode');

  const onSubmit = () => {
    const ageRange = ageRangeNodes.find(n => n.id === selectedAgeRange);
    const eventNode = nodes.filter(n => n.parentId === node.id && n.type == 'EventNode')[0];
    const bedNodes = nodes.filter(n => n.data.houseId === node.id && n.type == 'BedNode');
    onPaneClick();
    const newId = generateUniqueId(selectedAgeRange, allNodes);

    const newHouseNode = {
      ...node,
      id: newId,
      parentId: selectedAgeRange,
      data: {
        ...node.data,
        id: newId,
        ageRangeId: ageRange.data.id,
        ageRangeNodeDataId: selectedAgeRange
      }
    };

    const newEventNode = { ...eventNode, id: `${newId}E`, parentId: newId };

    const newBedNodes = bedNodes.map((bed, idx) => ({
      ...bed,
      id: `${newEventNode.id}${idx}`,
      parentId: newEventNode.id,
      data: {
        ...bed.data,
        ageRangeId: ageRange.data.id,
        ageRangeNodeDataId: selectedAgeRange,
        houseId: newId
      }
    }));

    // usuwamy stare elementy
    removeNode(node.id);

    // tworzymy nowe
    addNodesF([newHouseNode, newEventNode, ...newBedNodes]);

    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle id="add-new-house-dialog">Wybierz strefę</DialogTitle>
      <DialogContent>
        <Select
          variant="standard"
          labelId="age-ranges"
          value={selectedAgeRange}
          defaultValue={selectedAgeRange}
          label="Sezony"
          onChange={e => setSelectedAgeRange(e.target.value)}
        >
          {
            ageRangeNodes.map(obj => <MenuItem key={obj.id} value={obj.id}>{obj.data.label}</MenuItem>)
          }
        </Select>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button
            fullWidth
            variant="contained"
            endIcon={<Iconify icon={'eva:save-fill'} />}
            onClick={onSubmit}
          >
            Zapisz zmiany
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
